<template>
    <modal
        :modal-id="modalId"
        :title="modalTitle"
        :preloader="preloader"
        container-class="pdf-modal"
        :is-need-button-footer="false"
        @close-modal="closeModal"
    >
        <template slot="body">
			<app-overlay-loader v-if="preloader" />
            <div v-if="selectedUrl">
                <iframe
                    :src="selectedUrl"
                    width="100%"
                    height="100%"
                    style="border:none;"
                ></iframe>
            </div>
            <div v-else>
                <p>PDF tidak ditemukan.</p>
            </div>
        </template>
        
    </modal>
</template>

<script>
export default {
    name: "ModalViewPDF",

    props: {
        selectedUrl: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            modalId: 'show-pdf-modal',
            modalTitle: 'View PDF',
            preloader: false,
        };
    },

    methods: {
        closeModal() {
            this.$emit("close-modal");
        },
    },
};
</script>
<style scoped>
::v-deep(.modal-dialog) {
    width: 95% !important;
    max-width: 95% !important;

    height: 95% !important;
    max-height: 95% !important;

}
::v-deep( .modal-dialog .modal-content) {
    margin: 10px;
    height: 100% !important;
    max-height: 100% !important;
}


</style>
